import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAutoSize: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconAutoSize"><Path fillRule="evenodd" clipRule="evenodd" d="M6.5 2C5.11929 2 4 3.11929 4 4.5V19.5C4 20.8807 5.11929 22 6.5 22H17.5C18.8807 22 20 20.8807 20 19.5V4.5C20 3.11929 18.8807 2 17.5 2H6.5ZM5 4.5C5 3.67157 5.67157 3 6.5 3H17.5C18.3284 3 19 3.67157 19 4.5V19.5C19 20.3284 18.3284 21 17.5 21H13V13.5C13 12.1193 11.8807 11 10.5 11H5V4.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAutoSize;
